import styled from "@emotion/styled"
import { PButton, PHeading, PText } from "@porsche-design-system/components-react"
import { spacingStaticLg } from "@porsche-design-system/components-react/emotion"
import { defineMessages, FormattedMessage } from "react-intl"
import { formMessages } from "src/common/form.messages"

const messages = defineMessages({
	heading: {
		defaultMessage: "Thank you!",
		id: "feedbackForm.thanks.heading",
	},
	text: {
		defaultMessage: "Your feedback helps us to constantly improve our app.",
		id: "feedbackForm.thanks.text",
	},
})

interface FeedbackFormThanksProps {
	onClose?: () => void
}

export const FeedbackFormThanks = ({ onClose }: FeedbackFormThanksProps) => (
	<Container>
		<PHeading size="lg">
			<FormattedMessage {...messages.heading} />
		</PHeading>

		<PText>
			<FormattedMessage {...messages.text} />
		</PText>

		<PButton type="button" variant="secondary" icon="close" onClick={onClose}>
			<FormattedMessage {...formMessages.close} />
		</PButton>
	</Container>
)

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: start;
	gap: ${spacingStaticLg};
`
